import React, { useEffect, useState } from "react";
import { useAuditorEvaluateShareClient, useAuditorEvalStateClient, useAuditorActionStateClient, useAuditorAddEvalNoteClient, displayUser, generateOptions } from "../../../index";
import { Button, TextButton, Tooltip, ControlledCheckbox, ControlledSelect, Modal, Tag, Widget, ControlledInput } from "../../../styled";
import { Table, TableHeader, TableBody, TableBodyNoDataWrapper, TableLoadingWrapper } from "../../../styled";
import "./AuditorSoc1Intake.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faSpinner } from "@fortawesome/free-solid-svg-icons";
const AuditorSoc1Intake = ({
  activeShare
}) => {
  const [isLoading, setLoading] = useState(false);
  const [isRefreshLoading, setRefreshLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [evalStateMap, setEvalStateMap] = useState([]);
  const [actionStateMap, setActionStateMap] = useState([]);
  const [newNoteValue, setNoteValue] = useState('');
  const maxNotechar = 1000;
  const [modalProps, setModalProps] = useState({
    isOpen: false,
    selectedRow: {}
  });
  const [evaluateShare] = useAuditorEvaluateShareClient();
  const [addEvalNote] = useAuditorAddEvalNoteClient();
  const [setEvalState] = useAuditorEvalStateClient();
  const [setActionState] = useAuditorActionStateClient();
  useEffect(() => {
    setLoading(true);
    getStepsData();
  }, [activeShare]);
  const getStepsData = async () => {
    const resp = await evaluateShare({
      share_id: activeShare.share_id
    });
    const data = resp.steps.map((record, index) => {
      return {
        key: index,
        order: index + 1,
        step_id: record.step.step_id,
        name: record.step.name,
        evidence_type: record.step.evidence_type,
        document: {
          doc_name: record.document?.doc_name || ''
        },
        eval_state: {
          state: record.step.eval_state,
          eval_state_dt: record.step.eval_state_dt,
          eval_auditor_display_name: record.step.eval_auditor_display_name
        },
        action_state: {
          state: record.step.action_state,
          action_state_dt: record.step.action_state_dt,
          action_user_display_name: record.step.action_user_display_name
        },
        eval_notes: record.step.step_eval_notes,
        loading: false
      };
    });
    setTableData(data);
    setEvalStateMap(resp.step_eval_state_map);
    setActionStateMap(resp.step_action_state_map);
    setLoading(false);
    setRefreshLoading(false);
  };
  const setRecordLoading = (record, loading) => {
    const index = tableData.findIndex(row => row.step_id === record.step_id);
    tableData[index].loading = loading;
    setTableData([...tableData]);
  };
  const handleEvalStateChange = async (data, record) => {
    setRecordLoading(record, true);
    const resp = await setEvalState({
      step_id: record.step_id,
      eval_state: data.value
    });
    if (resp._http_status === 200) {
      const rowIndex = tableData.findIndex(row => row.step_id === record.step_id);
      tableData[rowIndex].eval_state.state = resp.step.eval_state;
      tableData[rowIndex].eval_state.eval_state_dt = resp.step.eval_state_dt;
      tableData[rowIndex].eval_state.eval_auditor_display_name = resp.step.eval_auditor_display_name;
      tableData[rowIndex].action_state.state = resp.step.action_state;
      tableData[rowIndex].action_state.action_state_dt = resp.step.action_state_dt;
      tableData[rowIndex].action_state.action_user_display_name = resp.step.action_user_display_name;
      setTableData([...tableData]);
    }
    setRecordLoading(record, false);
  };
  const handleActionStateChange = async (event, record) => {
    setRecordLoading(record, true);
    const resp = await setActionState({
      step_id: record.step_id,
      action_state: event.value ? 'change_made' : 'unset'
    });
    if (resp._http_status === 200) {
      const rowIndex = tableData.findIndex(row => row.step_id === record.step_id);
      tableData[rowIndex].action_state.state = resp.step.action_state;
      tableData[rowIndex].action_state.action_state_dt = resp.step.action_state_dt;
      tableData[rowIndex].action_state.action_user_display_name = resp.step.action_user_display_name;
      setTableData([...tableData]);
    }
    setRecordLoading(record, false);
  };
  const columns = [{
    dataKey: "order",
    label: "Order",
    columnStyles: {
      minWidth: "10px",
      width: "15%"
    }
  }, {
    dataKey: "name",
    label: "Business Process Control",
    columnStyles: {
      minWidth: "100px",
      width: "50%"
    }
  }, {
    dataKey: "evidence_type",
    label: "Control Type",
    columnStyles: {
      minWidth: "50px",
      width: "25%",
      textTransform: 'capitalize'
    },
    renderCell: (evidenceType, record) => {
      const colorMap = {
        policy: "orange",
        procedure: "blue",
        technical: "green"
      };
      return /*#__PURE__*/React.createElement(Tag, {
        label: evidenceType,
        color: colorMap[evidenceType] || 'blue',
        bordered: true
      });
    }
  }, {
    dataKey: "document",
    label: "File",
    columnStyles: {
      minWidth: "75px",
      width: "50%"
    },
    renderCell: (document, record) => {
      return /*#__PURE__*/React.createElement("a", {
        href: `/business/proxy/product/auditor/evaluate/soc1t2_intake/${record.step_id}`,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          maxWidth: "215px"
        }
      }, /*#__PURE__*/React.createElement(TextButton, {
        children: /*#__PURE__*/React.createElement("div", {
          style: {
            overflowWrap: 'anywhere'
          }
        }, document.doc_name)
      }));
    }
  }, {
    dataKey: "eval_state",
    label: "State",
    columnStyles: {
      minWidth: "50px",
      width: "50%"
    },
    renderCell: (evalState, record) => {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'row'
        }
      }, /*#__PURE__*/React.createElement(ControlledSelect, {
        disabled: record.loading,
        value: evalState.state,
        onChange: data => handleEvalStateChange(data, record),
        options: generateOptions(evalStateMap)
      })), /*#__PURE__*/React.createElement("div", {
        className: "user-display-container"
      }, `Set By: ${displayUser(evalState.eval_auditor_display_name, evalState.eval_state_dt)}`));
    }
  }, {
    dataKey: "action_state",
    label: "Change Made",
    columnStyles: {
      minWidth: "50px",
      width: "50%"
    },
    renderCell: (actionState, record) => {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'row'
        }
      }, /*#__PURE__*/React.createElement(ControlledCheckbox, {
        name: "action_state_checkbox",
        checked: actionState.state === 'unset' ? false : true,
        onChange: event => handleActionStateChange(event, record),
        disabled: record.loading
      })), /*#__PURE__*/React.createElement("div", {
        className: "user-display-container"
      }, `Set By: ${displayUser(actionState.action_user_display_name, actionState.action_state_dt)}`));
    }
  }];
  const expandedRowRenderView = record => {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        padding: '0px 5px'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, "Note:"), /*#__PURE__*/React.createElement("div", {
      style: {
        whiteSpace: 'pre-wrap',
        overflowWrap: 'anywhere',
        maxHeight: '50px',
        overflowY: 'auto'
      }
    }, record.eval_notes && record.eval_notes[0]?.note_text || ''), /*#__PURE__*/React.createElement("div", {
      className: "user-display-container"
    }, 'Added By: ', record.eval_notes && displayUser(record.eval_notes[0]?.note_user_display_name, record.eval_notes[0]?.eval_note_dt))), /*#__PURE__*/React.createElement("div", {
      style: {
        padding: '0px 5px',
        marginTop: '5px'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      styleType: "primary",
      onClick: () => {
        toggleModal(record);
      },
      children: "Add/View Notes"
    })));
  };
  const toggleModal = (record = null) => {
    if (modalProps.isOpen) {
      modalProps.isOpen = false;
      modalProps.selectedRow = {};
      setNoteValue('');
    } else {
      modalProps.isOpen = true;
      modalProps.selectedRow = record;
    }
    setModalProps({
      ...modalProps
    });
  };
  const handleAddNote = async record => {
    if (!newNoteValue.trim()) return;
    setRecordLoading(record, true);
    const resp = await addEvalNote({
      step_id: record.step_id,
      note: newNoteValue.trim()
    });
    if (resp._http_status === 200) {
      const rowIndex = tableData.findIndex(row => row.step_id === record.step_id);
      tableData[rowIndex].eval_notes = [{
        eval_note_dt: resp.step_eval_note.eval_note_dt,
        note_text: resp.step_eval_note.note_text,
        note_user_display_name: resp.step_eval_note.note_user_display_name
      }, ...tableData[rowIndex].eval_notes];
      setTableData([...tableData]);
      setNoteValue('');
    }
    setRecordLoading(record, false);
  };
  const renderModalContent = record => {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "add-note-container"
    }, /*#__PURE__*/React.createElement(ControlledInput, {
      multiline: true,
      rows: 4,
      disabled: record.loading,
      name: "controlled_input",
      onChange: data => {
        if (data.value.length <= maxNotechar) {
          setNoteValue(data.value);
        }
      },
      placeholder: "Write your note.",
      value: newNoteValue
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        margin: '1px',
        fontSize: '10px',
        color: "grey",
        display: 'flex',
        justifyContent: 'flex-end'
      }
    }, newNoteValue.length, " / ", maxNotechar), /*#__PURE__*/React.createElement("div", {
      style: {
        margin: '5px 0px',
        display: 'flex',
        justifyContent: 'flex-end'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: newNoteValue.trim() === '' || record.loading,
      loading: record.loading,
      styleType: "primary",
      onClick: () => {
        handleAddNote(record);
      },
      children: "Add Note"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "notes-modal-view-sub-container"
    }, record.eval_notes?.map((note, index) => /*#__PURE__*/React.createElement("div", {
      key: index,
      style: {
        padding: '10px 0px',
        borderBottom: '1px solid #f0f0f0'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, "Note:"), /*#__PURE__*/React.createElement("div", {
      style: {
        whiteSpace: 'pre-wrap',
        overflowWrap: 'anywhere'
      }
    }, note.note_text), /*#__PURE__*/React.createElement("div", {
      className: "user-display-container"
    }, `Added By: ${displayUser(note.note_user_display_name, note.eval_note_dt)}`)))));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-container"
  }, /*#__PURE__*/React.createElement(Widget, {
    title: /*#__PURE__*/React.createElement("div", null, activeShare.name, /*#__PURE__*/React.createElement("p", {
      className: "access-table-subtext"
    }, activeShare.account_key)),
    titleRowChildren: /*#__PURE__*/React.createElement(Tooltip, {
      tooltipChildren: /*#__PURE__*/React.createElement("p", null, "Refresh"),
      children: /*#__PURE__*/React.createElement(Button, {
        disabled: isRefreshLoading,
        styleType: "primary",
        onClick: () => {
          setLoading(true);
          setRefreshLoading(true);
          getStepsData();
        },
        children: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faArrowsRotate,
          size: "1x",
          spin: isRefreshLoading
        })
      })
    })
  }, /*#__PURE__*/React.createElement(TableLoadingWrapper, {
    columns: columns,
    rows: tableData,
    showRowLoading: isLoading,
    expandedRowRender: {
      isExpanded: !isLoading,
      view: expandedRowRenderView
    }
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHeader, null), /*#__PURE__*/React.createElement(TableBodyNoDataWrapper, null, /*#__PURE__*/React.createElement(TableBody, null))))), "`", /*#__PURE__*/React.createElement(Modal, {
    title: modalProps.selectedRow.name,
    modalIsOpen: modalProps.isOpen,
    close: toggleModal,
    clickAwayListener: true,
    width: 900,
    children: renderModalContent(modalProps.selectedRow)
  }));
};
export { AuditorSoc1Intake };